module.exports = __webpack_public_path__ + "img/egg.2089015b.svg";